import { IGoodgameClip } from "../clip/IGoodgameClip";

import Container = createjs.Container;
import Rectangle = createjs.Rectangle;

import { Signal } from "signals.js";

export class ClipSizeComponent {
    private _maxWidth: number;
    private _maxHeight: number;
    private _maxScale: number;
    private _minScale: number;
    private _offsetX: number;

    public get offsetX(): number {
        return this._offsetX;
    }

    private _offsetY: number;

    public get offsetY(): number {
        return this._offsetY;
    }

    private _scaleFactor: number;

    protected _clipSizeChanged: Signal = new Signal();

    public get clipSizeChanged(): Signal {
        return this._clipSizeChanged;
    }

    constructor(maxWidth: number, maxHeight: number, maxScale: number = -1, minScale: number = -1) {
        this._maxWidth = maxWidth;
        this._maxHeight = maxHeight;
        this._maxScale = maxScale;
        this._minScale = minScale;
    }

    public setImageSize(container: Container, bounds: Rectangle): void {
        this._scaleFactor = this.getScaleFactor(bounds, container);

        if (this._maxScale != -1) {
            this._scaleFactor = Math.min(this._maxScale, this._scaleFactor);
        }

        if (this._minScale != -1) {
            this._scaleFactor = Math.max(this._minScale, this._scaleFactor);
        }

        this._offsetX = -((bounds.width * this._scaleFactor) / 2 + bounds.left * this._scaleFactor);
        this._offsetY = -((bounds.height * this._scaleFactor) / 2 + bounds.top * this._scaleFactor);
        container.scaleX = container.scaleY = this._scaleFactor;
    }

    private getScaleFactor(bounds: Rectangle, container: Container): number {
        const boundsWidth: number = bounds.width != 0 ? bounds.width:  container.width;
        const boundsHeight: number = bounds.height != 0 ? bounds.height:  container.height;
        let scaleFactor: number = this._maxWidth / boundsWidth;

        if (boundsHeight * scaleFactor > this._maxHeight) {
            scaleFactor = this._maxHeight / boundsHeight;
        }
        return scaleFactor;
    }

    public destroy(): void {
        this._clipSizeChanged.removeAll();
    }
}
